import { action } from "typesafe-actions";
import {RequestData} from "models/axios";
import { User } from '@models/user'

export const enum AuthActionTypes {
    LOGIN_REQUEST = "@@auth/LOGIN_REQUEST",
    LOGIN_SUCCESS = "@@auth/LOGIN_SUCCESS",
    LOGIN_ERROR = "@@auth/LOGIN_ERROR",

    LOGOUT_REQUEST = "@@auth/LOGOUT_REQUEST",
    LOGOUT_SUCCESS = "@@auth/LOGOUT_SUCCESS",
    LOGOUT_ERROR = "@@auth/LOGOUT_ERROR",

    UPDATE_REQUEST = '@@auth/UPDATE_REQUEST',
    UPDATE_SUCCESS = "@@auth/UPDATE_SUCCESS",
    UPDATE_ERROR = '@@auth/UPDATE_ERROR',

    CHANGE_PASSWORD_REQUEST = '@@auth/CHANAGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_SUCCESS = '@@auth/CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_ERROR = '@@auth/CHANGE_PASSWORD_ERROR',

    RESET_PASSWORD_REQUEST = "@@auth/RESET_PASSWORD_REQUEST",
    RESET_PASSWORD_SUCCESS = "@@auth/RESET_PASSWORD_SUCCESS",
    RESET_PASSWORD_ERROR = "@@auth/RESET_PASSWORD_ERROR"

}

export const loginRequest = (data: {}) => action(AuthActionTypes.LOGIN_REQUEST, data);
export const loginSuccess = (data: {}) => action(AuthActionTypes.LOGIN_SUCCESS, data);
export const loginError = (message: string) => action(AuthActionTypes.LOGIN_ERROR, message);

export const updateRequest = (data:RequestData) => action(AuthActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: User[]) => action(AuthActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(AuthActionTypes.UPDATE_ERROR, message);

export const logoutRequest = (data: {}) => action(AuthActionTypes.LOGOUT_REQUEST, data);
export const logoutSuccess = (data: {}) => action(AuthActionTypes.LOGOUT_SUCCESS, data);
export const logoutError = (message: string) => action(AuthActionTypes.LOGOUT_ERROR, message);

export const changePasswordRequest = (data: {}) => action(AuthActionTypes.CHANGE_PASSWORD_REQUEST, data);
export const changePasswordSuccess = (data: {}) => action(AuthActionTypes.CHANGE_PASSWORD_SUCCESS, data);
export const changePasswordError = (message: string) => action(AuthActionTypes.CHANGE_PASSWORD_ERROR, message);

export const resetPasswordRequest = (data: {}) => action(AuthActionTypes.RESET_PASSWORD_REQUEST, data);
export const resetPasswordSuccess = (data: {}) => action(AuthActionTypes.RESET_PASSWORD_SUCCESS, data);
export const resetPasswordError = (message: string) => action(AuthActionTypes.RESET_PASSWORD_ERROR, message);


